<template>
  <section class="contact-area pb-90">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-box">
            <h3 class="title">修改密码</h3>
            
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="当前密码" prop="password">
                <el-input type="password" v-model="ruleForm.password" show-password autocomplete="off"></el-input>
              </el-form-item>
              
              <el-form-item label="新密码" prop="newpassword">
                <el-input type="password" v-model="ruleForm.newpassword" show-password autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="checkpassword">
                <el-input type="password" v-model="ruleForm.checkpassword" show-password autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { 
  chgpwd
 } from '@/api/auth';

export default {
  props: {
    profile: {
      type: Object,
      default: () => ({}) // 接收父组件传递的 profile 数据
    }
  },
  components: { 
  },
  data() {
    return {
      ruleForm: {
        password: '',
        newpassword: '',
        checkpassword: '',
      },
        rules: {
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
          ],
          newpassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, message: '新密码长度不能小于6位', trigger: 'blur' }
          ],
          checkpassword: [
            { required: true, message: '请输入确认密码', trigger: 'blur' },
            { min: 6, message: '确认密码长度不能小于6位', trigger: 'blur' },
            { validator: (rule, value, callback) => {
              if (value !== this.ruleForm.newpassword) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      initPwd() {
        return localStorage.getItem('initpwd');
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            chgpwd(this.ruleForm.password, this.ruleForm.newpassword).then((res) => {
              if (res.code === 200) {
                this.$message({ message: '修改成功', type: 'success' });
              } else {
                this.$message({
                  message: res.err || '更新失败',
                  type: 'error'
                });
              }
            });

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      setFormDefaults(profileData) {
        if (profileData) {
          this.ruleForm = {
            realname: profileData.realname || '',
            company: profileData.company || '',
            position: profileData.position || '', // 职务字段对应 profile.position
            email: profileData.email || '',
            summary: profileData.summary || ''
          };
        }
      }
    },
    watch: {
      // 监听 profile 变化，实时更新表单默认值
      profile: {
        handler(newProfile) {
          this.setFormDefaults(newProfile);
        },
        immediate: true // 初始化时立即执行
      }
    }
  };
</script>

<style></style>
